import { gql } from "@apollo/client"

const GET_TIMETABLE = gql`
  query($input: SessionTimetableInput!) {
    sessionTimetable(input: $input) {
      id
      last_updated_at
      groups {
        id
        title
        slots {
          id
          starts_at
          ends_at
          status
          booking {
            id
            student_initials
            booking_slot_id
            student_id
          }
        }
      }
    }
  }
`

export { GET_TIMETABLE }